import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Landing from "../views/Landing.vue";
import Home from "../views/Home.vue";
import RaceCard from "../views/RaceCard.vue";
import RaceCourse from "../views/RaceCourse.vue";
import Fixtures from "../views/Fixtures.vue";
import Statistics from "../views/Statistics.vue";
import CardChanges from "../views/CardChanges.vue";
import HorseStatistics from "../components/HorseStatistics.vue";
import JockeyStatistics from "../components/JockeyStatistics.vue";
import TrainerStatistics from "../components/TrainerStatistics.vue";
import Results from "../views/Results.vue";
import RaceStatistics from "../views/RaceStatistics";
import Downloads from "@/views/Downloads";
import Racereports from "@/views/Racereports";
import sectionalViewSelect from "../views/SectionalFilter.vue";
import SectionalReport from "../views/sectionalReport.vue";
import PositionBehindReport from "@/views/PositionBehindReport";
import PostionBehindFilter from "@/views/PostionBehindFilter";
import kmhPerSectFilter from "@/views/kmhPerSectFilter";
import distanceCoveredFilter from "@/views/distanceCoveredFilter";
import SectionalKMHReport from "@/views/SectionalKMHReport";
import SectionalPositionReport from "@/views/SectionalPositionReport";
import distanceCoveredSectionalFilter from "@/views/distanceCoveredSectionalFilter";
import distanceCoverdReport from "@/views/distanceCoverdReport";
import PositionAndTimeFilter from "../views/PositionAndTimeFilter.vue";
import PositionAndTimeReport from "../views/PostionAndTime.vue";
import SectionsToFinish from "../views/SectionsToFinishReport.vue";
import SectionsToFinshFilter from "../views/SectionsToFinishFilter.vue";
import PositionAndMarginBehindFilter from "../views/PositionAndMarginBehindFilter.vue";
import PositionAndMarginBehindReport from "../views/PositionAndMarginBehindReport.vue";
import SectionalTimeRank from "../views/SectionalTimeRank.vue";
import SectionalTimeRankReport from "../views/SectionalTimeRankReport.vue";

const index = [
  {
    path: "/",
    component: Login,
  },

  {
    path: "/landing",
    component: Landing,
    children: [
      {
        path: "PositionAndMarginBehindFilter",
        component: PositionAndMarginBehindFilter,
      },
      {
        path: "PositionAndMarginBehindReport",
        component: PositionAndMarginBehindReport,
      },
      {
        path: "SectionsToFinishReport",
        component: SectionsToFinish,
      },
      {
        path: "SectionsToFinishFilter",
        component: SectionsToFinshFilter,
      },
      {
        path: "SectoionalPositionAndTimeFilter",
        component: PositionAndTimeFilter,
      },
      {
        path: "SectionalPositionAndTime",
        component: PositionAndTimeReport,
      },
      {
        path: "SectionalDistanceCoveredReport",
        component: distanceCoverdReport,
      },
      {
        path: "SectionalDistanceCoveredFilter",
        component: distanceCoveredSectionalFilter,
      },
      {
        path: "SectionalPositionReport",
        component: SectionalPositionReport,
      },
      {
        path: "SectionalKMHReport",
        component: SectionalKMHReport,
      },
      {
        path: "PositionSectFilter",
        component: distanceCoveredFilter,
      },
      {
        path: "kmhPerSectFilter",
        component: kmhPerSectFilter,
      },
      {
        path: "positionBehindFilter",
        component: PostionBehindFilter,
      },
      {
        path: "positionBehindReport",
        component: PositionBehindReport,
      },
      {
        path: "sectionalReport100m",
        component: SectionalReport,
      },
      {
        path: "sectionalReportFilter",
        component: sectionalViewSelect,
      },
      {
        path: "downloads",
        component: Downloads,
      },
      {
        path: "racereports",
        component: Racereports,
      },
      {
        path: "home",
        component: Home,
      },
      {
        path: "racecard",
        component: RaceCard,
      },
      {
        path: "racecard/:date/:course/:rn",
        component: RaceCard,
      },
      {
        path: "racecourse",
        component: RaceCourse,
      },
      {
        path: "fixtures",
        component: Fixtures,
      },
      {
        path: "statistics",
        component: Statistics,
      },
      {
        path: "cardchanges",
        component: CardChanges,
      },
      {
        path: "horsestatistics",
        component: HorseStatistics,
      },
      {
        path: "jockeystatistics",
        component: JockeyStatistics,
      },
      {
        path: "trainerstatistics",
        component: TrainerStatistics,
      },
      {
        path: "results",
        component: Results,
      },
      {
        path: "racestatistics",
        component: RaceStatistics,
      },
      {
        path: "SectionalTimeRank",
        component: SectionalTimeRank,
      },
      {
        path: "SectionalTimeRankReport",
        component: SectionalTimeRankReport,
      },
    ],
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  routes: index,
});

export default router;
